import { getProductServerSideProps as getServerSideProps } from '@app/pages';
import MainLayout from "@shares/layouts/MainLayout";
import { Skeleton } from 'antd-mobile';
import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';

export { getServerSideProps };

export function Loading() {
  return (
    <div className={'px-5 py-4'}>
      <Skeleton
        animated
        style={{ height: 40 }}
        className={'mb-2'}
      />
      <Skeleton
        animated
        style={{ height: 40 }}
      />
    </div>
  )
}

const Page = dynamic(() => import('@features/digital-product/pages/index'), {
  loading: () => <Loading />
})

const IndexPage: NextPage = (pageProps: any) => {
  const { product, url } = pageProps

  return (
    <>
      <Head>
        <title>{product?.name}</title>
        <meta key="description" name="description" content={url} />
        <meta key="og-title" property="og:title" content={product?.name} />
        <meta key="og-description" property="og:description" content={url} />
        <meta property="og:image" content={product?.thumbnails[0].url} />
        <meta key="twitter-description" name="twitter:description" content={url} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta key="twitter-title" name="twitter:title" content={product?.name} />
        <meta name="twitter:image" content={product?.thumbnails[0].url} />
        <meta key="og-url" property="og:url" content={`https://${url}`} />
      </Head>
      <MainLayout>
        <Page data={product} />
      </MainLayout>
    </>
  )
}

export default IndexPage
